/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable @typescript-eslint/no-explicit-any */

import {
  CreateBulletinApiResponse,
  CreateBulletinBoardApiResponse,
  ReadBulletinApiResponse,
} from '../types/bulletinboardsApi.types';

/**
 * Transforms the create bulletin board api endpoint response.
 *
 * @param response The response from the endpoint.
 */
export function transformCreateBulletinBoardApiResponse(
  response: any,
): CreateBulletinBoardApiResponse {
  return { ...response.meta, ...response.data };
}

/**
 * Transforms the create bulletin endpoint response.
 *
 * @param response The response from the endpoint.
 */
export function transformCreateBulletinResponse(
  response: any,
): CreateBulletinApiResponse {
  return { ...response.data.meta, ...response.data.data };
}

/**
 * Transforms the read bulletin endpoint response.
 *
 * @param response The response from the endpoint.
 */
export function transformReadBulletinResponse(
  response: any,
): ReadBulletinApiResponse {
  return { ...response.data.meta, ...response.data.data };
}
